import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendContinuousOptimizationLinkCallToAction,
  BackendMutationCreateContinuousOptimizationLinkCallToActionArgs,
} from 'src/types/backend';

import { FRAGMENT_CO_CONVERSION_GOAL } from './schema';

const MUTATION = gql`
  mutation CreateCOConversionGoal($campaignId: ID!, $url: String!) {
    createContinuousOptimizationLinkCallToAction(campaignId: $campaignId, url: $url) {
      ...ContinuousOptimizationConversionGoal
    }
  }
  ${FRAGMENT_CO_CONVERSION_GOAL}
`;

type Variables = BackendMutationCreateContinuousOptimizationLinkCallToActionArgs;
type Result = BackendContinuousOptimizationLinkCallToAction;

export const createCOConversionGoal = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
